/**
 * Sentry Constants
 * Standardized error levels and tag names for consistent Sentry usage across the codebase
 */

/**
 * Error severity levels for Sentry
 * 
 * Usage guidelines:
 * - ERROR: Use for exceptions, failures, and critical issues that need immediate attention
 * - WARNING: Use for degraded performance, slow operations, or non-critical issues
 * - INFO: Use for state changes, successful operations, or informational events
 */
export const ERROR_LEVELS = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;

/**
 * Standardized tag names for Sentry events
 * 
 * All tags use snake_case for consistency and easier querying in Sentry dashboard
 */
export const TAGS = {
  ERROR_TYPE: 'error_type',
  HTTP_STATUS: 'http_status',
  HTTP_METHOD: 'http_method',
  API_TYPE: 'api_type',
  ERROR_CODE: 'error_code',
} as const;
